import React, { Component } from "react";
import { connect } from "react-redux";
import { LinearProgress } from "@material-ui/core";
import "../libs/styles/signin.css";
import {
  signinUserIn,
  setLoading,
  showMessage,
  handleAppError,
} from "../actions";
import { QRInsurancePDFIcon } from "../libs/SVGIcons";
import { ErrorBoundary } from "react-error-boundary";
import axios from "../axios";
import { Button } from "@material-ui/core";
import AppConfig from "../constants/AppConfig";

class QRPage extends Component {
  state = {
    details: null,
  };
  constructor() {
    super();
  }
  componentDidMount() {
    this.props.setLoading(false);
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.no) {
      document.title = "#" + params.no + " insurance details";
      this.getInsuranceDetails(params.no);
    }
  }
  async getInsuranceDetails(no) {
    const { handleAppError } = this.props;
    try {
      console.log("getting insurance details ...");
      const response = await axios.get("/qr-insurance", {
        params: {
          no: no,
        },
      }),
        details = response.data.data;
      await this.setState({
        details: details,
      });
    } catch (error) {
      handleAppError(error);
    }
  }
  errorFallback({ error, resetErrorBoundary }) {
    return (
      <div role="alert">
        <p>{window.sys_app_translate("Something went wrong", "en")}:</p>
        <pre>{error.message}</pre>
        <button onClick={resetErrorBoundary}>
          {window.sys_app_translate("Try again", "en")}
        </button>
      </div>
    );
  }
  render() {
    const { loading } = this.props,
      { details } = this.state;
    return (
      <ErrorBoundary FallbackComponent={this.errorFallback} onReset={() => { }}>
        {loading && (
          <div
            className="container-fluid"
            style={{ position: "fixed", zIndex: "100000" }}
          >
            <LinearProgress color="primary" />
            <LinearProgress color="primary" />
          </div>
        )}
        {details && (
          <div className="container-fluid qr-page" style={{ height: "100vh" }}>
            <div className="row d-flex justify-content-center align-content-center">
              <div className="col-11 col-md-8 col-lg-5 col-xl-4 d-flex justify-content-center">
                <div className="container-fluid">
                  <div className="row my-3">
                    <div className="col-12 text-center">
                      {/* TODO: Check or modify brand logo -i */}
                      {/* <img
                        style={{ height: "10rem" }}
                        src={require("../assets/system-agency-logo-for-qr-insurance-page.png")}
                      /> */}
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="container-fluid details-container">
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate(
                            "Poliçe Numarası(Policy No)",
                            "en"
                          )}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.policyno}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate("Ürün No", "en")}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.policyid}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate(
                            "Tarife Adı(Tariff Name)",
                            "en"
                          )}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {window.sys_app_translate(details.type, "en")}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate(
                            "Başlangıç Tarihi(Begin Date)",
                            "en"
                          )}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.startdate}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate(
                            "Bitiş Tarihi(End Date)",
                            "en"
                          )}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.enddate}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate("TC / Passport", "en")}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.identityno}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate(
                            "Sigortalı Adı Soyadı(Client Name)",
                            "en"
                          )}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.customername}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate(
                            "Sigortalı Yaş(Client Age)",
                            "en"
                          )}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.customerage}
                        </div>
                      </div>
                      <div className="row my-3 justify-content-center">
                        <div className="col-7 qr-detail-sub-title inter inter-medium">
                          {window.sys_app_translate("Fiyat(Price)", "en")}
                        </div>
                        <div className="col-5 text-center qr-detail-sub-value">
                          {details.price}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-conetnt-center mt-2">
                    <div className="col-12 d-flex justify-content-center">
                      <Button
                        variant="outlined"
                        className="inter inter-bold"
                        style={{ border: "1px solid white" }}
                        color="default"
                        startIcon={<QRInsurancePDFIcon />}
                        onClick={(e) => {
                          window.open(
                            AppConfig.storagePath +
                            details.file.substring(1, details.file.length),
                            "_blank"
                          );
                        }}
                      >
                        <span style={{ color: "white" }}>
                          {window.sys_app_translate("PDF", "en")}
                        </span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row justify-content-center">
              <div className="col-6 qr-detail-sub-title inter inter-medium">
                {window.sys_app_translate("Acente (Agency)", "en")}
              </div>
              <div className="col-6 text-center">{details.agency}</div>
            </div> */}
          </div>
        )}
      </ErrorBoundary>
    );
  }
}

// map state to props
const mapStateToProps = ({ authUser, appReducer }) => {
  const { user } = authUser;
  const { loading } = appReducer;
  return { user, loading };
};

export default connect(mapStateToProps, {
  signinUserIn,
  setLoading,
  showMessage,
  handleAppError,
})(QRPage);